import PropTypes from 'prop-types';
import { MdOutlineInsertComment, MdComment } from 'react-icons/md';

import { Line } from '../../../../utils/globalPropTypes';
import { useWorkReportModals } from '../../../../context/WorkReportModalsContext';

const CommentsWorkReportButton = (props) => {
  const { line, startDate, canVisualizeComments, canSendComments, monthly } = props;

  const { activeCommentsModal } = useWorkReportModals();

  return (
    <button
      className="button_work_report"
      disabled={!canVisualizeComments || line?.bloqueadoEnSap}
      onClick={() => {
        activeCommentsModal(
          {
            ...line,
            startDate,
            monthly
          },
          () => {},
          !canSendComments || !line.estadoRevision.comentario
        );
      }}
      style={{
        opacity: line?.bloqueadoEnSap ? '0.3' : ''
      }}
      type="button"
    >
      {line.comentarios ? (
        <MdComment className="comment_button" />
      ) : (
        <MdOutlineInsertComment className="not_comment_button" />
      )}
    </button>
  );
};

CommentsWorkReportButton.propTypes = {
  line: Line.isRequired,
  startDate: PropTypes.string.isRequired,
  canVisualizeComments: PropTypes.bool,
  canSendComments: PropTypes.bool,
  monthly: PropTypes.bool
};

CommentsWorkReportButton.defaultProps = {
  canVisualizeComments: true,
  canSendComments: true,
  monthly: false
};

export default CommentsWorkReportButton;
